'use client';
import { observer } from 'mobx-react-lite';
import { useStores } from '@/models';
import UKDialog from '@/components/UKDialog';
import { useEffect, useState } from 'react';
import { generateOneLink } from '@/utils/deepLink';
import clientApp from '@/utils/client.app';
import { uaParse } from '@/intl-jdi-common-ssr/utils/uaParser';
import { useTranslation } from '@/i18n/client';
import PromotionExpiredDialog from '@/components/PromotionExpiredDialog';
import UKToast from '@/components/UKToast';
import clearChannelActivityData from '@/utils/activityUtil';

interface StockDialogProps {
  code?: string;
  message?: string;
  isAppDealOnly?: number;
  showOverlay?: boolean; // 新增prop
}

export const StockDialog = ({
  code,
  message,
  isAppDealOnly,
  showOverlay = false,
}: StockDialogProps) => {
  const { t } = useTranslation();
  const { cmsDialogStore } = useStores();
  const { isDialogOpen, openDialog, closeDialog } = cmsDialogStore;
  const [openDialogFlag, setOpenDialogFlag] = useState(false);
  const [toastShown, setToastShown] = useState(false); // 新增状态，标记Toast是否已显示
  const [openPromotionExpiredDialog, setOpenPromotionExpiredDialog] = useState(false);

  function downloadApp() {
    const url = generateOneLink();
    console.log(url);
    url && (window.location.href = url);
  }

  // 处理Toast消失后的逻辑
  const handleToastDismissed = () => {
    // 清除渠道活动数据
    clearChannelActivityData();
    // 刷新页面
    const url = new URL(window.location.href);
    url.searchParams.set('_t', Date.now().toString());
    window.location.href = url.toString();
  };
  useEffect(() => {
    // 当skuList长度为0且弹窗未打开时，触发弹窗
    if (code && code === '400024' && !isDialogOpen) {
      setOpenDialogFlag(true);
      openDialog();
    }
    // 当code为400027时，根据是否在App内显示不同内容
    else if (code && code === '400027') {
      if (!uaParse().isInJoybuyApp) {
        // 不在App内：打开PromotionExpiredDialog
        setOpenPromotionExpiredDialog(true);
      } else {
        // 在App内：使用UKToast显示消息
        if (!toastShown) {
          UKToast.show({
            content: message || t('common.message.SorryThisEventHasEnded'),
            icon: 'warning',
            duration: 3000, // 假设Toast显示3秒，根据实际UKToast组件调整
          });
          setToastShown(true); // 标记Toast已显示
          setTimeout(() => {
            handleToastDismissed && handleToastDismissed();
          }, 3000);
        }
      }
    }
    // 移除了原有的蒙层显示逻辑，现在由服务端直接控制
  }, [code, isDialogOpen, openDialog, isAppDealOnly]);

  const handleConfirm = () => {
    // 去首页、刷新
    if (uaParse().isInJoybuyApp) {
      clientApp.goToHomepage();
    } else {
      location.href = '/';
    }
    // 确认按钮点击处理
    closeDialog();
  };

  const handlePromotionExpiredCancel = () => {
    setOpenPromotionExpiredDialog(false);
    clearChannelActivityData();
    const url = new URL(window.location.href);
    url.searchParams.set('_t', Date.now().toString());
    window.location.href = url.toString();
  };

  return (
    <>
      {/* 透明蒙层 - 直接使用服务端传递的showOverlay prop */}
      {showOverlay && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'transparent',
            zIndex: 1250, // 低于弹窗的z-index
          }}
          onClick={downloadApp}
        />
      )}

      {/* UKDialog - 无论是否在App内都会显示 */}
      <UKDialog
        open={openDialogFlag}
        handleClose={handleConfirm}
        customButtonText={t('common.message.OpenJoybuy')}
      >
        <div>
          <p>{`${t('common.message.SorryThisEventHasEnded')}`}</p>
        </div>
      </UKDialog>

      {/* PromotionExpiredDialog - 用于code为400027且不在App内的情况 */}
      <PromotionExpiredDialog
        open={openPromotionExpiredDialog}
        content={message + ''} // 使用传入的message
        handleCancel={handlePromotionExpiredCancel}
      />
    </>
  );
};
